var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.pdf)?_c('div',{staticClass:"flip-book-container",attrs:{"src":_vm.pdf}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }